'use client';

import { Flex } from '@coolblue-development/freddy';
import type { EnergyLabelProps } from '@coolblue-development/next-energy-label/client';
import { EnergyLabel } from '@features/product/components/Shared/client';
import type { EnergyLabelType, SubProducts } from '@features/product/typings';

type EnergyLabelContainerProps = {
  energyLabel?: EnergyLabelType;
  subProducts: SubProducts[];
  flexDirection?: 'row' | 'column';
  direction?: EnergyLabelProps['direction'];
  size?: EnergyLabelProps['size'];
  isOrderSummary?: boolean;
};

export const EnergyLabelContainer = ({
  energyLabel,
  subProducts,
  flexDirection = 'column',
  direction = 'right',
  size = 'large',
  isOrderSummary = false
}: EnergyLabelContainerProps) => {
  const renderEnergyLabel = (label?: EnergyLabelType, key?: number) =>
    label && (
      <EnergyLabel
        key={key}
        energyLabel={label}
        direction={direction}
        size={size}
        trackingFeatureName={isOrderSummary ? 'order_block_summary' : 'order_block'}
        bypassSubsidiaryCheck
      />
    );

  if (subProducts?.length) {
    return (
      <Flex gap={200} direction={flexDirection}>
        {subProducts.map((subProduct, index) =>
          renderEnergyLabel(subProduct?.product?.energyLabel, index)
        )}
      </Flex>
    );
  }

  return renderEnergyLabel(energyLabel) || null;
};
